import {vnTemplate} from "./vnTemplate";

declare var ko: any;

/**
 * Represents a simple confirmation dialog.
 *
 * @class
 * @extends vnTemplate
 */
export class simpleConfirmDialog_template extends vnTemplate {
    protected buildViewModel(): any {
        return {

            message: ko.observable(`Are you sure you want to do this?`),
            isVisible: ko.observable(false),
            userResponse: ko.observable(null),
            onCancel: () => {
                //will be overridden
                console.log('NO')
            },
            onConfirm: (element) => {
                //will be overridden
                console.log('YES')
            }
        };
    }

    protected getTemplateHtml(): string {
        return `
    <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isVisible }">
         <div class="img-picker-content popup-warning">
             <div class="w-form lightbox-form">
                 <div class="form-header">
                    <h3 class="form-title icon i-notice-alert">Warning</h3>
                 </div>
                 
                 <div class="form-body warning-body">
                     <div class="form-group">
                        <div class="warning-content" data-bind="html : message"></div>
                     </div>
                 </div>
                 
                 <div class="form-footer">
                    <button data-bind="click : onCancel" class="btn" type="button">Cancel</button>
                    <button data-bind="click : onConfirm" class="btn highlight" type="button">OK</button>
                 </div>
             </div>    
         </div>
    </div>
        `;
    }

    protected getTemplateName(): string {
        return "simpleConfirmDialog_template";
    }


    public setDialogMessage(message : string){
        this.getTemplateViewModel().message(message);
    }

    public getDialogUserResponse(){
        return this.getTemplateViewModel().userResponse();
    }


    /**
     * Displays a confirmation dialog and returns a Promise that resolves with a boolean value indicating
     * whether the user confirmed or canceled the dialog.
     *
     * @returns {Promise<boolean>} A Promise that resolves with a boolean value. True if the user confirmed
     * the dialog, false if the user canceled the dialog.
     */
    public showConfirmDialog = (): Promise<boolean> => new Promise((resolve) => {
        this.getTemplateViewModel().isVisible(true);

        // Override onCancel and onConfirm methods to resolve the promise
        this.getTemplateViewModel().onCancel = () => {
            resolve(false);
            this.getTemplateViewModel().userResponse('NO')
            this.getTemplateViewModel().isVisible(false);

        };

        this.getTemplateViewModel().onConfirm = () => {
            resolve(true);
            this.getTemplateViewModel().userResponse('YES')
            this.getTemplateViewModel().isVisible(false);
        };
    });
}


// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleConfirmDialog_template.ts